import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { BIBlue, BIGrey, BILightGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import {
  FETCH_CLIENT_SUPPORT_CATEGORIES,
  FETCH_CLIENT_SUPPORT_URGENCY_LIST,
  SAVE_CLIENT_SUPPORT,
  SAVE_CLIENT_SUPPORT_PICTURE
} from "../../constant/Apipath";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function AddClientSupport({ open, handleClose, setLoadNew }) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const { selectedClientData } = useSelector((state) => state?.main);

  const imgRef = useRef(null);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewerIndex, setPictureViewerIndex] = useState(0);

  const [supportImages, setSupportImages] = useState([]);
  const [urgencyList, setUrgencyList] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [categoryPage, setCategoryPage] = useState(1);
  const [categoryHasMore, setCategoryHasMore] = useState(true);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [categorySelectWidth, setCategorySelectWidth] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const modalRef = useRef(null);
  const urgencySelectRef = useRef(null);
  const categorySelectRef = useRef(null);
  const LANGUAGE = ClientEnglishFallback.AddClientSupport(
    multiLanguageData?.AddClientSupport || {}
  );
  const [pickerOpen, setPickerOpen] = useState(false);

  const {
    TEXT_DESCRIPTION_LABEL,
    TEXT_DESCRIBE_THE_PROBLEM_PLACE_HOLDER,
    TEXT_URGENCY_LABEL,
    TEXT_SELECT_OPTION_PLACE_HOLDER,
    TEXT_EXPECTED_COMPLETION_DATE_LABEL,
    TEXT_CATEGORY_LABEL,
    TEXT_SELECT_CATEGORY_PLACE_HOLDER,
    BUTTON_SUBMIT,
    TEXT_CHOOSE_A_DATE
  } = LANGUAGE;

  const [clientSupport, setClientSupport] = useState({
    description: "",
    urgency: { id: -1, name: "Select Option" },
    ecDate: null,
    category: { id: -1, supportCategoryName: TEXT_SELECT_CATEGORY_PLACE_HOLDER }
  });

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    await getSupportList();
    await getCategories();
    setIsLoading(false);
  };

  const getSupportList = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [
          {
            FieldName: "id",
            Direction: "ASC"
          }
        ]
      };
      const supportResponse = await Postrequestcall(
        FETCH_CLIENT_SUPPORT_URGENCY_LIST,
        obj,
        loginData?.accessToken
      );
      if (supportResponse.status === 200) {
        const newData = [
          { id: -1, name: TEXT_SELECT_OPTION_PLACE_HOLDER, disabled: true },
          ...supportResponse?.data?.data
        ];
        setUrgencyList(newData);
      } else {
        console.log("getSupportList-> Error Getting Client Support Urgency List");
      }
    } catch (error) {
      console.log("getSupportList-> Error Getting Client Support Urgency List: ", error);
    }
  };

  const getCategories = async (page = 1) => {
    if (categoryLoading) return;
    setCategoryLoading(true);
    try {
      let obj = {
        PageNr: page,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [
          {
            FieldName: "id",
            Direction: "ASC"
          }
        ]
      };
      const categoryResponse = await Postrequestcall(
        FETCH_CLIENT_SUPPORT_CATEGORIES,
        obj,
        loginData?.accessToken
      );
      if (categoryResponse.status === 200) {
        const responseData = categoryResponse?.data?.data || [];
        if (page === 1) {
          const newData = [
            {
              id: -1,
              supportCategoryName: TEXT_SELECT_CATEGORY_PLACE_HOLDER,
              disabled: true
            },
            ...responseData
          ];
          setCategoryData(newData);
        } else {
          setCategoryData(prev => [...prev, ...responseData]);
        }
        setCategoryHasMore(responseData.length === 20);
        setCategoryPage(page);
      } else {
        console.log("getCategories-> Error Getting Client Suport Categories");
      }
    } catch (error) {
      console.log("getCategories-> Error Getting Client Suport Categories: ", error);
    }
    setCategoryLoading(false);
  };

  const getMenuProps = (isCategory = false, selectWidth = 0) => ({
    PaperProps: {
      style: {
        width: selectWidth > 0 ? `${selectWidth}px` : 'auto',
        maxHeight: 250,
      },
      sx: {
        zIndex: 1500,
        '& .MuiMenuItem-root': {
          whiteSpace: 'normal !important',
          wordBreak: 'break-word !important',
          display: 'block',
          py: 1,
        },
        '& .MuiList-root': {
          py: 0
        }
      },
      onScroll: isCategory ? (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 50;
        if (bottom && categoryHasMore && !categoryLoading) {
          getCategories(categoryPage + 1);
        }
      } : undefined
    },
    disablePortal: false,
    disableScrollLock: true,
  });

  const handleShowInput = () => {
    imgRef.current.click();
  };

  const handleInputChange = (value, field) => {
    setClientSupport((prevState) => ({
      ...prevState,
      [field]: value
    }));
  };

  const handleSetImages = (e) => {
    const allData = e.target.files;
    const newImages = [];
    let invalidFile = false;
    Array.from(allData).forEach((img) => {
      if (img.type.startsWith("image/")) {
        newImages.push({
          file: img,
          url: URL.createObjectURL(img)
        });
      } else {
        invalidFile = true;
      }
    });
    if (invalidFile) {
      alert("Please select image files only.");
    }
    if (newImages.length > 0) {
      setSupportImages((prevImages) => [...prevImages, ...newImages]);
    }
    e.target.value = null;
  };

  const handelImageDelete = (index) => {
    let temp = [...supportImages];
    temp.splice(index, 1);
    setSupportImages(temp);
  };

  const shouldDisable = () => {
    return (
      clientSupport.description !== "" && clientSupport.urgency.id !== -1
      // &&
      // clientSupport.ecDate !== null
    );
  };

  const saveSupportData = async () => {
    setIsLoading(true);
    try {
      const obj = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        UserId: loginData?.userInformation?.UserId,
        SaveList: [
          {
            Id: 0,
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            Description: clientSupport.description,
            UrgencyId: clientSupport.urgency.id,
            ECDate: clientSupport.ecDate,
            SupportCategoryId: clientSupport.category.id,
            Status: "Open",
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const isMessageSent = await Postrequestcall(SAVE_CLIENT_SUPPORT, obj, loginData?.accessToken);
      if (isMessageSent.status === 201) {
        if (supportImages?.length !== 0) {
          let formDataArray = supportImages?.map((img) => {
            let formData = new FormData();
            formData.append("Id", 0);
            formData.append("SupportId", isMessageSent?.data?.data[0].objData.id);
            formData.append("FileName", img.file);
            formData.append("ModifiedBy", loginData?.userInformation?.UserId);
            return formData;
          });
          let promises = formDataArray?.map((formData) =>
            Fileuploadrequestcall(SAVE_CLIENT_SUPPORT_PICTURE, formData, loginData?.accessToken)
          );
          await Promise.all(promises);
        }
        handleClose(true);
      } else {
        console.log("saveSupportData-> Error When Saving Client Support Data");
      }
    } catch (error) {
      console.log("saveSupportData-> Error When Saving Client Support Data: ", error);
    }
    setIsLoading(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-add-client-support"
      aria-describedby="modal-add-client"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300
      }}
    >
      <>
        {isLoading ? (
          <Loader fullScreen />
        ) : (
            <Box
              sx={{
                width: { xs: "90%", sm: "80%", md: "60%", lg: "30%" },
                maxWidth: "500px",
                maxHeight: "90vh",
                bgcolor: "background.paper",
                boxShadow: "0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
                borderRadius: { xs: "8px", sm: "10px" },
                p: 2,
                display: "flex",
                flexDirection: "column",
                outline: "none",
                position: "relative",
                overflow: "visible"
              }}
            >
              <Box
                ref={modalRef}
                sx={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  flex: 1
                }}
              >
            <Grid container spacing={1}>
              <Grid size={12}>
                <IconButton
                  sx={{
                    display: "flex",
                    justifySelf: "flex-end",
                    color:
                      selectedClientData?.AccentColor !== undefined &&
                        selectedClientData?.AccentColor
                        ? selectedClientData?.AccentColor
                        : BILightGrey
                  }}
                  onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid size={12}>
                <Typography variant="body1">{TEXT_DESCRIPTION_LABEL}</Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  required
                  fullWidth
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    handleInputChange(inputValue, "description");
                  }}
                  value={clientSupport.description}
                  minRows={4}
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  placeholder={TEXT_DESCRIBE_THE_PROBLEM_PLACE_HOLDER}
                  className="add-support"
                  sx={{
                    "& fieldset": { border: "none" }
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Typography variant="body1" sx={{ mb: 1 }}>{TEXT_URGENCY_LABEL}</Typography>
                <Select
                  ref={urgencySelectRef}
                  fullWidth
                  size="small"
                  value={clientSupport.urgency.id} // Use only the `id` for the value
                  onChange={(e) => {
                    const selected = urgencyList.find((option) => option?.id === e.target.value);
                    handleInputChange(selected, "urgency"); // Set full object on change
                  }}
                  sx={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px",
                    "& fieldset": { border: "none" }
                  }}
                  MenuProps={getMenuProps(false)}
                  renderValue={(selectedValue) => {
                    const selectedOption = urgencyList.find(
                      (option) => option?.id === selectedValue
                    );
                    return selectedOption ? selectedOption.name : ""; // Return the `name` of the selected urgency
                  }}>
                  {urgencyList?.filter((v, i, a) => a.findIndex(t => t.name === v.name) === i)?.map((option, index) => (
                    <MenuItem key={index} value={option?.id} disabled={option?.disabled}>
                      {option?.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid size={12}>
                <Typography variant="body1">{TEXT_EXPECTED_COMPLETION_DATE_LABEL}</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box
                    onClick={() => setPickerOpen(true)}
                    sx={{
                      height: "40px",
                      backgroundColor: "#e4e4e4",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0 10px",
                      cursor: "pointer"
                    }}>
                    <span>
                      {clientSupport.ecDate && dayjs.isDayjs(clientSupport.ecDate)
                        ? dayjs(clientSupport.ecDate).isSame(dayjs(), "day")
                          ? `${dayjs(clientSupport.ecDate).format("MMM DD, YYYY")} (Today)`
                          : dayjs(clientSupport.ecDate).format("MMM DD, YYYY")
                        : null}
                    </span>
                    <InsertInvitationIcon
                      sx={{
                        color: selectedClientData?.AccentColor,
                        cursor: "pointer"
                      }}
                    />
                  </Box>
                  <MobileDatePicker
                    open={pickerOpen}
                    onOpen={() => setPickerOpen(true)}
                    onClose={() => setPickerOpen(false)}
                    format="MMM DD, YYYY"
                    value={clientSupport.ecDate}
                    onChange={(newDate) => {
                      handleInputChange(newDate, "ecDate");
                    }}
                    // defaultValue={dayjs()}
                    sx={{ display: "none" }} // Hide the actual picker input
                  />
                </LocalizationProvider>
              </Grid>
              <Grid size={12}>
                <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>{TEXT_CATEGORY_LABEL}</Typography>
                <Select
                  ref={categorySelectRef}
                  size="small"
                  required
                  fullWidth
                  value={clientSupport.category.id} // Use only the `id` for the value
                  onChange={(e) => {
                    const selected = categoryData.find((option) => option?.id === e.target.value);
                    handleInputChange(selected, "category"); // Set full object on change
                  }}
                  onOpen={() => {
                    if (categorySelectRef.current) {
                      setCategorySelectWidth(categorySelectRef.current.offsetWidth);
                    }
                  }}
                  sx={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px",
                    "& fieldset": { border: "none" }
                  }}
                  MenuProps={getMenuProps(true, categorySelectWidth)}
                  renderValue={(selectedValue) => {
                    const selectedOption = categoryData.find(
                      (option) => option?.id === selectedValue
                    );
                    return selectedOption ? selectedOption.supportCategoryName : ""; // Return the `name` of the selected urgency
                  }}>
                  {categoryData?.filter((v, i, a) => a.findIndex(t => t.supportCategoryName === v.supportCategoryName) === i)?.map((option, index) => (
                    <MenuItem key={index} value={option?.id} disabled={option?.disabled}>
                      {option?.supportCategoryName}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid size={12} sx={{ overflowX: "auto", display: "flex" }} marginTop={1}>
                <Box
                  onClick={handleShowInput}
                  padding={5}
                  height={20}
                  borderRadius={2}
                  marginRight={1}
                  border={"1px solid rgb(204, 204, 204)"}>
                  <AddIcon sx={{ color: BIGrey, fontSize: "larger" }} />
                </Box>
                <div
                  style={{
                    maxWidth: "100%",
                    overflow: "auto",
                    display: "flex",
                    gap: "10px"
                  }}>
                  {supportImages?.map((image, index) => (
                    <div className="remove-div" key={index}>
                      <img
                        onClick={() => {
                          setPictureViewerOpen(true);
                          setPictureViewerIndex(index);
                        }}
                        loading="lazy"
                        src={image.url}
                        alt={image?.id}
                        style={{
                          objectFit: "cover",
                          cursor: "pointer",
                          borderRadius: "8px",
                          maxWidth: "100px",
                          height: "100px",
                          minWidth: "100px",
                          border: "1px solid rgb(204, 204, 204)"
                        }}
                        height={100}
                      />
                      <IconButton
                        style={{
                          color:
                            selectedClientData?.AccentColor !== undefined &&
                              selectedClientData?.AccentColor
                              ? selectedClientData?.AccentColor
                              : BILightGrey,
                          backgroundColor: "rgba(0,0,0,0.3)"
                        }}
                        onClick={() => handelImageDelete(index)}
                        className="remove-icon">
                        <CloseIcon />
                      </IconButton>
                    </div>
                  ))}
                </div>
                <input
                  multiple
                  ref={imgRef}
                  onChange={handleSetImages}
                  type="file"
                  name="support-img"
                  id="support-img"
                  accept="image/*"
                  style={{ display: "none" }}
                />
              </Grid>
              <Grid size={12} sx={{ overflowX: "auto", display: "flex" }} marginTop={1}>
                <Button
                  disabled={!shouldDisable()}
                  variant="contained"
                  fullWidth
                  onClick={saveSupportData}
                  sx={{
                    backgroundColor: selectedClientData?.AccentColor,
                    textTransform: "none"
                  }}>
                  {BUTTON_SUBMIT}
                </Button>
              </Grid>
            </Grid>
              </Box>
            </Box>
          )}
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          pictures={supportImages?.map((img) => {
            return { src: img.url };
          })}
          viewerIndex={pictureViewerIndex}
        />
      </>
    </Modal>
  );
}

export default AddClientSupport;
